import baseUrl from "./base"
import {postRequest, postRequestCustomHeaders, getRequest, getRequestCustomHeaders} from "./common"


const record17Api = {
    //分頁查詢代理商記錄
    "getAgentInfoListByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record17/getAgentInfoListByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                addinfo3: null,  //companycode
                pageNum: 1,
                pageSize: 10
            }
        }
    },
    //刪除代理商記錄
    "delRecord17ByID": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record17/delRecord17ByID`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                id: null,
            }
        }
    },
    //添加代理商記錄
    "insertAgentRecord": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record17/insertAgentRecord`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,  //代理商公司代碼
                addinfo1: null,  //供應商acccompanycode
                addinfo2: null,  //供應商login
                addinfo3: null,  //供應商companycode
            }
        }
    },
    //分頁查詢供應商記錄
    "getSupplierInfoListByPage": {
        send: (data, callback, failCallback, errorCallback) => {
            postRequest(`${baseUrl.shopopeeHttp}record17/getSupplierInfoListByPage`, data, callback, failCallback, errorCallback)
        },
        getParams: () => {
            return {
                companycode: null,  //companycode
                pageNum: 1,
                pageSize: 10
            }
        }
    },
}

export default record17Api